<template>
   <div>
      <div style="font-weight: lighter; font-size: small;">
         <button :class="{ 'mb': true, 'is-active': isActive('bold') }" @click="command('bold')">
            <i class="material-icons">format_bold</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('italic') }" @click="command('italic')">
            <i class="material-icons">format_italic</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('underline') }" @click="command('underline')">
            <i class="material-icons">format_underline</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('strike') }" @click="command('strike')">
            <i class="material-icons">format_strikethrough</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('heading({ level: 1 })'), 'align-top': true }"
            @click="command('h1')">
            <i class="mi-heading">H1</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('bullet_list') }" @click="command('bullet_list')">
            <i class="material-icons">format_list_bulleted</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('ordered_list') }" @click="command('ordered_list')">
            <i class="material-icons">format_list_numbered</i>
         </button>
         <button @click="command('undo')" class="mb">
            <i class="material-icons">undo</i>
         </button>
         <button @click="command('redo')" class="mb">
            <i class="material-icons">redo</i>
         </button>
         <button @click="command('manage_imgs')" class="mb">
            <i class="material-icons">image</i>
         </button>
         <div class="field-ddl align-top">
            <select v-model="selectedImgId">
               <template v-if="images && images.length > 0">
                  <option v-for="opt in images" :value="opt.corrTemplateImageId" :key="opt.orrTemplateImageId">Image: {{
                     opt.imageName }}</option>
               </template>
               <option value="null" v-else>(No Images)</option>
            </select>
            <a class="align-top" @click="command('image')" role="button">
               <span class="mi-heading">+</span>
            </a>
         </div>
         <div class="field-ddl align-top">
            <select v-model="selected">
               <option v-for="option in fields" :value="option.id" :key="option.id">{{ option.label }}</option>
            </select>
            <a class="align-top" @click="command('field')" role="button">
               <span class="mi-heading">+</span>
            </a>
         </div>

         <button class="align-top mb" @click="command('help')">
            <span class="mi-heading">?</span>
         </button>
      </div>
      <bubble-menu class="bubble-menu" :tippy-options="{ animation: false }" :editor="editor" v-if="editor"
         v-show="editor.isActive('custom-image')">
         <button 
            @click="editor.chain().focus().setImage({ size: 'small' }).run()" 
            :class="{ 'is-active': editor.isActive('custom-image', { size: 'small' }) }"
         >
            Small
         </button>
         <button 
            @click="editor.chain().focus().setImage({ size: 'medium' }).run()" 
            :class="{ 'is-active': editor.isActive('custom-image', { size: 'medium' })}"
         >
            Medium
         </button>
         <button 
            @click="editor.chain().focus().setImage({ size: 'large' }).run()" 
            :class="{ 'is-active': editor.isActive('custom-image', { size: 'large' })}"
         >
            Large
         </button>
      </bubble-menu>

      <div id="modalImages" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalImageLabel"
         aria-hidden="true">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="modalImageLabel">
                     <i class="material-icons">image</i>
                     Manage Your Images
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div v-if="templateId!=0">
                     <p class="instructions">
                        To add an image, please upload the image by entering a name, choosing a file, and
                        clicking the upload button. You can also delete images using the X button below but be
                        sure and delete them from the template as well.
                     </p>
                     <div class="row">
                        <div class="col-sm-3">Name:</div>
                        <div class="col-sm-9">
                           <input type="text" class="form-control" placeholder="(Enter name for image)" id="imageName"
                              v-model="curImageName">
                        </div>
                     </div>
                     <div class="row mart-12">
                        <div class="col">
                           <div id="drop-area">
                              <div v-for="(fyl, index) in droppedFiles" :key="index" class="drop-file">
                                 <i class="fa fa-file-alt"></i>
                                 {{ fyl.name }}
                                 <span @click.prevent="deleteFile(fyl.name)"><i
                                       class="fa fa-times font-smaller text-danger"></i></span>
                              </div>
                              <div v-if="droppedFiles.length == 0" class="drop-msg">
                                 DRAG a DOCUMENT HERE<br />
                                 <input type="file" name="file" id="file" class="inputfile" @change="inputFileChanged" />
                                 <label for="file">or [Click to Choose a File]</label>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="row mart-12">
                        <div class="col-sm-8 instructions text-muted ">
                           PNG, JPG, or GIF only
                        </div>
                        <div class="col-sm-4 text-right">
                           <button type="button" class="btn ml-bk-corp ml-white ml-h-black upload-btn"
                              @click.prevent="uploadPressed">
                              <i class="fi-interface-upload"></i>
                              UPLOAD
                           </button>
                        </div>
                     </div>
                     <div class="scroll-body2 mart-12">
                        <h3>Uploaded Images</h3>
                        <table class="fld-table table table-condensed table-striped">
                           <thead>
                              <tr>
                                 <th width="90%">Image Name</th>
                                 <th>Del</th>
                              </tr>
                           </thead>
                           <tbody v-if="images && images.length > 0">
                              <tr v-for="(itm, indx) in images" :key="indx">
                                 <td>{{ itm.imageName }}</td>
                                 <td><a @click="deleteUpload(itm)" role="button"><i class="fas fa-times" role="button"
                                          style="color: red;"></i></a></td>
                              </tr>
                           </tbody>
                           <tbody v-else>
                              <tr>
                                 <td colspan="2">(No images uploaded yet...)</td>
                              </tr>
                           </tbody>

                        </table>
                     </div>
                  </div>
                  <div v-else>
                     Please save the template once before adding images...
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="ok-btn btn ml-bk-corp ml-white ml-h-black" @click.prevent="imageOKPressed">
                     <i class="fas fa-check"></i>
                     OK
                  </button>
               </div>
            </div>
         </div>
      </div>

      <div id="modalHelp" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalHelpLabel"
         aria-hidden="true">
         <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="modalHelpLabel">
                     <i class="fi-interface-telephone"></i>
                     Editor Help
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="text-right marb-12 help-nav">
                     <a href="#EDITOR">EDITOR</a> &bull;
                     <a href="#FIELDS">FIELDS</a> &bull;
                     <a href="#IMAGES">IMAGES</a>
                  </div>
                  <div class="scroll-body">
                     <a name="EDITOR"></a>
                     <h3>Editor:</h3>
                     <p>
                        The purpose of this editor is to be able to save a reusable email template to use later on when
                        sending
                        emails to various recipients. The template will have numerous "placeholders" for fields (gray and
                        starting with "@Field:") where the system will merge in data at the time you decide to use the
                        template
                        to send an actual email.
                     </p>
                     
                     <a name="FIELDS"></a>
                     <h3>Fields:</h3>
                     <p>To insert a field, choose it from the dropdown and click the plus button. To remove the field just
                        use the
                        delete or backspace keys on your keyboard deleting the placeholder.
                     </p>
                     <p>
                        Here is a list of what each field is and what data will take its place:
                     </p>
                     <table class="fld-table table table-condensed table-striped">
                        <thead>
                           <tr>
                              <th width="30%">Placeholder</th>
                              <th>Description</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="(itm, indx) in fields" :key="indx">
                              <td>{{ itm.label }}</td>
                              <td>{{ itm.description }}</td>
                           </tr>
                        </tbody>
                     </table>

                     <a name="IMAGES"></a>
                     <h3>Images:</h3>
                     <p>
                        Inserting images is a two step process. First, add an image to the repository by clicking the add
                        image
                        toolbar button and uploading. Once uploaded, the image will appear in the toolbar's image dropdown.
                        Then secondly, you can add an image to the template by choosing it from the dropdown and clicking
                        the Plus button.
                     </p>
                     <p>
                        <em>To address storage concerns, note that your image may be <b>automatically</b> reduced in size when
                           uploading.</em>
                     </p>
                     <p>
                        In this editor, images can be 3 sizes - small, medium, or large. Hover over an image to see the menu
                        to change its size. To remove an image just use the delete or backspace keys on your keyboard
                        deleting the image in the editor.
                     </p>
                     <ul class="font-smaller">
                        <li><em>Small:</em> Renders the image 80px wide and a height appropriate to the aspect ratio.</li>
                        <li><em>Medium:</em> Renders the image 300px wide and a height appropriate to the aspect ratio.</li>
                        <li><em>Large:</em> Renders the image the same size as it was when it was uploaded. Note - If the upload
                           size was too big, the system reduces the size and it will render at the reduced size.   
                        </li>
                     </ul>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="ok-btn btn ml-bk-corp ml-white ml-h-black" @click.prevent="helpOKPressed">
                     <i class="fas fa-check"></i>
                     OK
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2'


export default {
   name: 'CustomEditorMenu',
   components: {
      BubbleMenu
   },
   props: {
      editor: Object,
      fields: Array,
      images: Array,
      templateId: Number
   },
   data() {
      return {
         selected: 1,
         selectedImgId: this.images && this.images.length > 0 ? this.images[0].corrTemplateImageId : null,
         baseField: '<code class="code-field">@</code>',
         imgUrlPrefix: process.env.VUE_APP_BASE_API_URL + 'img/',
         curImageName: '',
         droppedFiles: [],
         maxDroppedFiles: 1,
         minDroppedFiles: 1,
         dropArea: null,
         sending: false
      }
   },
   computed: {
      selectedField: function () {
         var itm = this.fields.find(o => o.id === this.selected)
         return itm
      },
      selectedImage: function () {
         var itm = this.images.find(o => o.corrTemplateImageId === this.selectedImgId)
         return itm
      }
   },
   watch: {
      images: function updateSelected(newVal) {
         if (newVal && newVal.length > 0) {
            this.selectedImgId = newVal[0].corrTemplateImageId
         }
      }
   },
   async mounted() {
      $(window).on('shown.bs.modal', async function (e) {
         if (e.target.id == 'modalHelp') {
            $('#modalHelp').modal('show')
            let dv = document.getElementsByClassName('scroll-body')
            if (dv) {
               dv = dv[0]
               dv.scrollTop = 0
            }
         }
      })

      //Handle attachment drag-n-drop
      this.initializeDragNDrop()
   },
   methods: {
      command(cmdKey) {
         let url = ''
         let file = ''
         if (this.selectedImage) {
            file = `${this.selectedImage.corrTemplateImageId}.${this.selectedImage.imageTypeCode}`
            url = `${this.imgUrlPrefix}${file}`
         }
         let c
         if (this.selectedField) {
            c = this.baseField.replace('@', '@' + this.selectedField.label)
         }

         switch (cmdKey) {
            case 'bold':
               this.editor.chain().focus().toggleBold().run()
               break
            case 'italic':
               this.editor.chain().focus().toggleItalic().run()
               break
            case 'underline':
               this.editor.chain().focus().toggleUnderline().run()
               break
            case 'strike':
               this.editor.chain().focus().toggleStrike().run()
               break
            case 'h1':
               break
            case 'bullet_list':
               this.editor.chain().focus().toggleBulletList().run()
               break
            case 'ordered_list':
               this.editor.chain().focus().toggleOrderedList().run()
               break
            case 'undo':
               this.editor.chain().focus().undo().run()
               break
            case 'redo':
               this.editor.chain().focus().redo().run()
               break
            case 'manage_imgs':
               $('#modalImages').modal('show')
               break
            case 'field':
               this.editor.commands.insertContent(c)
               break
            case 'image':
               if (this.selectedImage && url != '') {
                  this.addImage(url)
               }
               break
            case 'help':
               $('#modalHelp').modal('show')
               break
         }
      },
      addImage(url) {
         if (url) {
            this.editor.chain().focus().setImage({ src: url }).run()
         }
      },
      isActive(actKey) {
         if (this.editor)
            return this.editor.isActive(actKey)
         return false
      },
      helpOKPressed() {
         $('#modalHelp').modal('hide')
      },
      imageOKPressed() {
         $('#modalImages').modal('hide')
      },

      // ---upload related METHODS

      async deleteUpload(itm) {
         await this.$template.deleteTemplateImage(itm.corrTemplateImageId)
            .then(async (r) => {
               this.$emit('image-uploaded', true)
               if (r != true) {
                  this.$swal(
                     "Image Deletion Failed",
                     "The image deletion partially failed. Please try again later",
                     "error"
                  )
               }
            })
      },

      inputFileChanged(ev) {
         let fileName = '';
         fileName = ev.target.value.split('\\').pop()
         let files = ev.target.files
         if (files.length < 1) {
            return
         }
         let file = files[0]
         const low = file.name.toLowerCase()
         if (  (low.indexOf(".jpg") < 0) &&
               (low.indexOf(".png") < 0) &&
               (low.indexOf(".gif") < 0)  )
         {
            this.$swal(
               "Invalid File",
               "The file you are uploading must be one of these types:<br />(JPG, PNG, GIF)",
               "error"
            )
            return
         }
         if (file.size > 2000000) {
            this.$swal(
               "Invalid File",
               "The file you are uploading is too big. It must be 2MB or smaller.",
               "error"
            )
            return
         }

         // Its good. Lets keep it
         this.droppedFiles.push(file)
      },
      deleteFile(fyl) {
         let indx = 99;
         let df = [];
         for (var i = 0; i < this.droppedFiles.length; i++) {
            if (this.droppedFiles[i].name != fyl) {
               df.push(this.droppedFiles[i]);
            }
         }
         this.droppedFiles = df;
      },
      // Drag-N-Drop functions
      initializeDragNDrop() {
         this.dropArea = document.getElementById("drop-area");
         ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.preventDefaults, false)
         })

         this.dropArea.addEventListener("drop", this.handleDrop, false);
         ["dragenter", "dragover"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.highlight, false)
         });
         ["dragleave", "drop"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.unhighlight, false)
         })
      },
      highlight(e) {
         this.dropArea.classList.add("highlight")
      },
      unhighlight(e) {
         this.dropArea.classList.remove("highlight")
      },
      preventDefaults(e) {
         e.preventDefault()
         e.stopPropagation()
      },
      handleDrop(e) {
         // ---- Drag N Drop method of Adding Files
         this.handleFiles(e)
      },
      handleFileUpload() {
         // ---- Manual method of adding files (mobile)
         var file = this.$refs.inpfile.files[0]
         const low = file.name.toLowerCase()
         if (low.indexOf(".png") < 0 &&
            low.indexOf(".jpg") < 0 &&
            low.indexOf(".gif") < 0
         ) {
            this.$swal(
               "Invalid File",
               "The file you are uploading must be one of these types:<br />PNG, JPG, or GIF",
               "error"
            )
            return
         }
         if (file.size > 2000000) {
            this.$swal(
               "Invalid File",
               "The file you are uploading is too big. It must be 2MB or smaller.",
               "error"
            )
            return
         }
         // Its good. Lets keep it
         this.droppedFiles.push(file)
      },
      handleFiles(ev) {
         // Use DataTransferItemList interface to access the file(s)
         for (var i = 0; i < ev.dataTransfer.items.length; i++) {
            // Validate the dropped file
            if (ev.dataTransfer.items[i].kind === "file") {
               var file = ev.dataTransfer.items[i].getAsFile()
               const low = file.name.toLowerCase()
               if (low.indexOf(".png") < 0 &&
                  low.indexOf(".jpg") < 0 &&
                  low.indexOf(".gif") < 0
               ) {
                  this.$swal(
                     "Invalid File",
                     "The file you are uploading must be one of these types:<br />PNG, JPG, or GIF",
                     "error"
                  )
                  return
               }
               if (file.size > 2000000) {
                  this.$swal(
                     "Invalid File",
                     "The file you are uploading is too big. It must be 2MB or smaller.",
                     "error"
                  )
                  return
               }

               // Its good. Lets keep it
               this.droppedFiles.push(file)
            }
         }
      },
      async uploadPressed() {
         if (this.curImageName.trim() == '') {
            this.$swal(
               "Image Name Required",
               "Please enter a name for your file.",
               "error"
            )
            return;
         }
         if (this.droppedFiles.length > this.maxDroppedFiles) {
            this.$swal(
               "Too Many Images at Once",
               "Please select 1 file to upload at a time.",
               "error"
            )
            return;
         }
         if (this.droppedFiles.length < this.minDroppedFiles) {
            this.$swal(
               "Upload What?",
               "You must choose at least one file to upload.",
               "error"
            )
            return;
         }

         this.sending = true
         let formData = new FormData()
         formData.append("files", this.droppedFiles[0]); //only the first
         formData.append("corrTemplateId", this.templateId)
         formData.append("ImageName", this.curImageName)
         formData.append("userId", this.$store.getters.appUser.userId)

         this.uploadPercentage = 0
         this.$swal({
            title: "Please Wait",
            html: "<i class='fas fa-2x fa-spinner fa-spin ml-corp'></i>",
            showConfirmButton: false
         })

         let token = await this.$auth.Token()
         axios.post(process.env.VUE_APP_BASE_API_URL + "document/imgup",
            formData,
            {
               withCredentials: true,
               headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': `Bearer ${token}`
               },
               onUploadProgress: function (progressEvent) {
                  this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
               }.bind(this)
            }
         ).then(r => {
            this.$swal.close()
            this.sending = false
            this.$swal(
               "Success",
               "We have successfully received your upload.",
               "success"
            ).then(() => {
               // delete uploaded docs from dropzone
               this.droppedFiles = []
               this.curImageName = ""
               this.$emit('image-uploaded', true)
            })
         })
            .catch(e => {
               this.$swal.close()
               this.sending = false
               this.$swal(
                  "System Error",
                  "Oops! Something happened along the way and your upload cannot be submitted at this time. Please try again later or contact support.",
                  "error"
               )
            });

      }
   }
}
</script>
 
<style lang="scss" scoped>
@import '~material-design-icons/iconfont/material-icons.css';
@import '../assets/css/colors.scss';

.mi-heading {
   color: #000;
   line-height: 30px;
   font-size: 20px;
   font-style: normal;
   vertical-align: middle;
   margin: 0;
}

.field-ddl {
   display: inline-block;
   height: 30px;
   font-size: small;
   padding: 2px 4px 0 4px;
   border-right: 1px solid #fff;
}

.field-ddl select {
   height: 26px;
   width: 260px;
   margin-top: 2px;

   &:focus {
      outline: none !important;
   }
}

.field-ddl option:focus {
   outline: none !important;
}

.field-ddl a {
   padding: 0 6px;
   font-weight: bold;
}

.ProseMirror {

   & img {
      width: 100%;
      height: auto;
      display: block;
      margin-left: auto;
      margin-right: auto;

      &.ProseMirror-selectednode {
         outline: 3px solid #68cef8;
      }
   }

   & .custom-image-small {
      max-width: 200px;
   }

   & .custom-image-medium {
      max-width: 500px;
   }

   & .custom-image-large {
      max-width: 100%;
   }
}

.bubble-menu {
   display: flex;
   background-color: #0d0d0d;
   padding: 0.2rem;
   border-radius: 0.5rem;

   button {
      border: none;
      background: none;
      color: #fff;
      font-size: 0.85rem;
      font-weight: 500;
      padding: 0 0.2rem;
      opacity: 0.6;

      &:hover,
      &.is-active {
         opacity: 1;
      }

      &.is-active {
         text-decoration: underline;
      }
   }
}

.scroll-body {
   max-height: 600px;
}

.scroll-body2 {
   min-height: 100px;
   max-height: 300px;
}

.scroll-body,
.scroll-body2 {
   overflow-x: hidden;
   overflow-y: auto;
   padding-right: 12px;

   & h3 {
      color: orange;
      font-size: 1em;
   }

   & p {
      font-size: 0.75em;
   }
}

.fld-table {
   font-size: small
}

.ok-btn {
   width: 100px;
}

/* Drag N drop related styles */
.upload-btn,
.upload-btn:focus {
   outline: none !important;
}

#drop-area {
   background-color: #ddd;
   border: 2px dashed $corp-color;
   border-radius: 12px;
   width: 100%;
   height: 100px;
   text-align: center;
   vertical-align: middle;
   font-size: 0.8em;
   padding-top: 24px;

   & .drop-file {
      color: $corp-color;
   }
}

.highlight {
   box-shadow: inset 0px 0px 6px 6px rgba(0, 167, 161, 0.9);
}

.inputfile {
   width: 0.1px;
   height: 0.1px;
   opacity: 0;
   overflow: hidden;
   position: absolute;
   z-index: -1;
}

.inputfile+label {
   display: inline-block;
   cursor: pointer;
}

.inputfile:focus+label,
.inputfile+label:hover {
   color: $corp-color;
}

.drop-msg {
   font-family: corporate-s, sans-serif !important;
}

.text-lighter {
   opacity: 0.25;
}
.help-nav a {
   font-size: 0.75em;
}
</style>